import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { getAmplifyConfig } from './amplify-config.js';
import { App } from './App.js';

Amplify.configure(getAmplifyConfig());

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).catch((error: unknown) => {
    console.error('Synphant service worker registration failed', error);
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
